import React, { useState } from "react";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import { Alert, Button, Spin } from "antd"; // Using Ant Design Input for better UI consistency
import Input from "Components/UI/Input";

import { PlusCircle, Trash2 } from "react-feather";
import { useGetDeductionsQuery } from "../../../../AppQuries/payroll/deduction/get-all-deduction";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import { format } from "date-fns";
const Deduction = () => {
  const {
    control,
    register,
    setValue,
    getValues,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();
  const {
    data: deduction,
    isLoading,
    isError,
    error,
  } = useGetDeductionsQuery({
    companyCode: watch("companyCode"),
  });

  const [index, setIndex] = useState(0);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "deductionDetails",
    keyName: "id",
  });

  const deductionData = Array.isArray(deduction?.data)
    ? deduction?.data
        // .filter((data) => data.isActive === true)
        .map((o) => ({
          id: o.code,
          label: o.description,
          value: o.code,
        }))
    : [];

  const deductionDetails = watch("deductionDetails") || [];

  const adddeduction = () => {
    const newdeduction = {
      companyCode: watch("companyCode"),
      code: 0,
      employeeCode: watch("employeeCode"),
      description: "",
      haveCPF: false,
      isTaxPayable: false,
      createUser: watch("createUser"),
      modifyUser: watch("modifyUser"),
      createDate: watch("createDate"),
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      isActive: true,
      amount: "",
      effectiveDateFrom: null,
      effectiveDateTo: null,
      departmentCode: watch("departmentCode"),
      isEditable: true,
    };
    setValue("deductionDetails", [...deductionDetails, newdeduction]);
  };

  const removeDeduction = (id) => {
    const updateddeductions = deductionDetails.find((_, i) => i !== index);
    setValue("deductionDetails", updateddeductions);
  };

  const selectDeductionHandler = (e, index) => {
    const selecteddeduction = deduction?.data.find((d) => d.code == e);

    if (selecteddeduction) {
      setValue(`deductionDetails[${index}].code`, selecteddeduction.code);
      setValue(
        `deductionDetails[${index}].description`,
        selecteddeduction.description
      );
      setValue(
        `deductionDetails[${index}].isTaxPayable`,
        selecteddeduction.isTaxPayable
      );
      setValue(`deductionDetails[${index}].haveCpf`, selecteddeduction.haveCpf);
    }
    trigger(`deductionDetails[${index}].code`);
    trigger(`deductionDetails[${index}].description`);
  };
  
  if (isLoading) return <Spin spinning={isLoading} />;
  if (isError) return <Alert type="warning" message={error.message} />;

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h4></h4>
        <button
          className="btn btn-secondary btn-sm"
          type="button"
          onClick={adddeduction}
        >
          <PlusCircle className="me-2" />
          Add Deduction
        </button>
      </div>
      <div className="table-responsive" style={{ minHeight: "300px" }}>
        <table className="table custom-table table-nowrap mb-0">
          <thead>
            <tr>
              <th>-</th>
              <th>Deduction Name</th>
              <th>Amount</th>
              {/* <th>Effective From</th>
              <th>Effective To</th> */}
            </tr>
          </thead>
          <tbody>
            {/* {deductionDetails.map((data, index) => ( */}
            {fields.map(
              (field, index) =>
                !field.isTemporary && (
                  <tr key={field.id}>
                    <td>
                      <Button
                        type="danger"
                        onClick={() => remove(index)}
                        disabled={!field.isEditable}
                      >
                        <Trash2 />
                      </Button>
                    </td>
                    <td className="form-floating">
                      {/* <Controller
                                    name={`deductionDetails[${index}].code`}
                                    control={control}
                                    defaultValue={2}
                                    render={({ field }) => ( */}
                      <Input
                        name={`deductionDetails[${index}].code`}
                        type="commonSelect"
                        className={`form-control ${
                          errors.deductionDetails?.[index]?.code
                            ? "is-invalid"
                            : ""
                        }`}
                        options={deductionData}
                        placeholder="Select Deduction"
                        onSelect={(e) => selectDeductionHandler(e, index)}
                        value={deductionData.find(
                          (option) =>
                            option.value ===
                            watch(`deductionDetails[${index}].code`)
                        )}
                        readOnly={!`deductionDetails[${index}].isEditable`}
                      />
                      {/* )}
                                  />
                                  {errors?.deductionDetails?.[index]?.code ||
                                    (errors?.deductionDetails?.[index]?.description && (
                                      <div className="invalid-feedback">
                                        Please select an allowance
                                      </div>
                                    ))} */}
                    </td>
                    <td>
                      {/* <Controller
                                    name={`deductionDetails[${index}].amount`}
                                    control={control}
                                    render={({ field }) => ( */}
                      <Input
                        name={`deductionDetails[${index}].amount`}
                        label=""
                        className={`form-control ${
                          errors.deductionDetails?.[index]?.amount
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder=""
                        type="number"
                        required={false}
                        labelClassName=""
                        requiredMessage="This field is required"
                        defaultValue={
                          watch(`deductionDetails[${index}].amount`) || 0
                        }
                        readOnly={!`deductionDetails[${index}].isEditable`}
                      />
                      {/* )}
                                  /> */}
                      {/* {errors?.deductionDetails?.[index]?.amount && (
                                    <div className="invalid-feedback">
                                      {errors.deductionDetails?.[index]?.amount?.message}
                                    </div>
                                  )} */}
                    </td>
                    {/* <td>
                      <Input
                        name={`deductionDetails[${index}].effectiveDateFrom`}
                        type="date"
                        placeholder="Select Effective From Date"
                        className={`form-control ${
                          errors.deductionDetails?.[index]?.effectiveDateFrom
                            ? "is-invalid"
                            : ""
                        }`}
                        label=""
                        labelClassName="form-label"
                        required={false}
                        requiredMessage=""
                        defaultValue={
                          watch(
                            `deductionDetails[${index}].effectiveDateFrom`
                          ) || null
                        }
                        dateFormat="YYYY-MM-DD"
                        disabledDate={(current) => {
                          return (
                            current < dayjs().subtract(1, "day").endOf("day")
                          );
                        }}
                        readOnly={!`deductionDetails[${index}].isEditable`}
                      />
                    </td>

                    <td>
                      <Input
                        name={`deductionDetails[${index}].effectiveDateTo`}
                        type="date"
                        placeholder="Select Effective To Date"
                        className={`form-control ${
                          errors.deductionDetails?.[index]?.effectiveDateTo
                            ? "is-invalid"
                            : ""
                        }`}
                        label=""
                        labelClassName="form-label"
                        required={false}
                        requiredMessage=""
                        defaultValue={
                          watch(`deductionDetails[${index}].effectiveDateTo`) ||
                          null
                        }
                        dateFormat="YYYY-MM-DD"
                        disabledDate={(current) => {
                          const effectiveDateFrom = dayjs(
                            watch("effectiveDateFrom")
                          );
                          return (
                            current < dayjs().subtract(1, "day").endOf("day") ||
                            current < effectiveDateFrom
                          );
                        }}
                        readOnly={!`deductionDetails[${index}].isEditable`}
                      />
                    </td> */}
                  </tr>
                )
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Deduction;
